export const getLocalShowMenuNotification = async () => {
  if (localStorage.getItem('showMenuNotification')) {
    return await JSON.parse(localStorage.getItem('showMenuNotification'))
  } else {
    return true
  }
}
